/**
 * File global.ts.
 *
 * Handles global TypeScript for your theme.
 */

interface Window {
    mobileBreakpoint: number;
    isWidthMobile: () => boolean;
    wpRig?: Element | null;
}

declare let window: Window;

window.mobileBreakpoint = 55;

window.isWidthMobile = (): boolean => {
    const fontSizeStr = getComputedStyle(document.documentElement).fontSize.slice(0, -2);
    const fontSize = parseFloat(fontSizeStr);
    const emValue = window.innerWidth / fontSize;
    const test = document.querySelector('.wp-rig');
    window.wpRig = test;
    return emValue <= window.mobileBreakpoint;
};

function isChromeForcedDarkMode() {
    // Create a temporary test element
    const testElement = document.createElement('div');
    testElement.style.backgroundColor = 'rgb(255, 255, 255)'; // White background
    document.body.appendChild(testElement);

    // Get computed style
    const computedStyle = window.getComputedStyle(testElement);
    const backgroundColor = computedStyle.backgroundColor;
    
    // Remove test element after checking
    document.body.removeChild(testElement);

    console.log('Computed Background Color:', backgroundColor);

    // Check if background color is dark (forced dark mode turns white to black)
    return backgroundColor === 'rgb(0, 0, 0)'; // Black background means dark mode is forced
}

document.addEventListener("DOMContentLoaded", function () {

    if(isChromeForcedDarkMode()) {
        document.body.classList.add('dark-mode');
    }

    const dropdown = document.querySelectorAll(".locale-switcher-dropdown");
    for (let i = 0; i < dropdown.length; i++) {
        if (dropdown[i]) {
            dropdown[i].addEventListener("click", function () {
                let menu = this.querySelector(".dropdown-menu");
                if (menu) {
                    menu.style.display = menu.style.display === "block" ? "none" : "block";
                }
            });
    
            // Close dropdown when clicking outside
            document.addEventListener("click", function (event) {
                if (!dropdown[i].contains(event.target as Node)) {
                    const menu = dropdown[i].querySelector(".dropdown-menu");
                    if (menu) {
                        menu.style.display = "none";
                    }
                }
            });
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    let menuCatButton = document.querySelector('.category-dropdown-menu .category-nav-inner.btn');
    let isHomePage = !!document.querySelector('.home');
    let menuCat = document.querySelector('.category-dropdown-menu .category-dropdown-wrap');

    if (menuCat && isHomePage) {
        menuCat.classList.add('active');
    }

    if (menuCatButton && !isHomePage) {
        menuCatButton.addEventListener('click', (e) => {
            e.preventDefault();
            let menuCat = document.querySelector('.category-dropdown-menu .category-dropdown-wrap');
            if (menuCat) {
                menuCat.classList.toggle('active');
            }
        });

        document.addEventListener('click', (e) => {
            let menuCat = document.querySelector('.category-dropdown-menu .category-dropdown-wrap');
            if (menuCat && !menuCat.contains(e.target as Node) && !menuCatButton.contains(e.target as Node)) {
                menuCat.classList.remove('active');
            }
        });
    }
});

// JavaScript to toggle sidebar menu
document.addEventListener('DOMContentLoaded', function () {
    const menuIcon = document.querySelector('.sidebar-menu-icon-wrap');
    const sidebar = document.querySelector('.sidebar-menu-wrap');
    const closeButton = document.querySelector('.sidebar-menu-close');
    const sidebarOverlay = document.querySelector('.sidebar-cart-overlay');

    if (menuIcon && sidebar && closeButton && sidebarOverlay) {
        menuIcon.addEventListener('click', function () {
            sidebar.classList.add('active');
            sidebarOverlay.classList.add('active');
        });

        closeButton.addEventListener('click', function () {
            sidebar.classList.remove('active');
            sidebarOverlay.classList.remove('active');
        });

        sidebarOverlay.addEventListener('click', function () {
            sidebar.classList.remove('active');
            sidebarOverlay.classList.remove('active');
        });
    }

    const tabLinks = document.querySelectorAll('.sidebar-menu-wrap .nav-link');
    const tabContents = document.querySelectorAll('.sidebar-menu-wrap .tab-pane');

    if (tabLinks.length > 0 && tabContents.length > 0) {
        tabLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();

                tabLinks.forEach(link => link.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));

                link.classList.add('active');
                const targetTab = document.querySelector(link.getAttribute('href'));
                if (targetTab) {
                    targetTab.classList.add('active');
                }
            });
        });
    }
});

// jQuery for Cart
jQuery(function ($) {
    function refreshMiniCart() {
        if (!$('.sidebar-cart-wrap').length) return;

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: { action: 'woocommerce_get_refreshed_fragments' },
            success: function (response) {
                if (response.fragments) {
                    $('.sidebar-cart-wrap').html(response.fragments['div.widget_shopping_cart_content']);
                    $('.sidebar-cart-wrap').addClass('active');
                    $('.sidebar-cart-overlay').addClass('active');
                }
            }
        });
    }

    if ($('.mini-cart-link').length) {
        $(document).on('click', '.mini-cart-link', function (e) {
            e.preventDefault();
            $('.sidebar-cart-wrap').addClass('active');
            $('.sidebar-cart-overlay').addClass('active');
        });
    }

    if ($('.sidebar-cart-close, .sidebar-cart-overlay').length) {
        $(document).on('click', '.sidebar-cart-close, .sidebar-cart-overlay', function () {
            $('.sidebar-cart-wrap').removeClass('active');
            $('.sidebar-cart-overlay').removeClass('active');
        });
    }

    $(document.body).on('added_to_cart removed_from_cart', function () {
        if (!$('.sidebar-cart-wrap').length) return;

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: { action: 'woocommerce_get_refreshed_fragments' },
            success: function (response) {
                if (response.fragments) {
                    $.each(response.fragments, function (key, value) {
                        $(key).html(value);
                    });
                }
            }
        });
    });

    if ($('.btn-remove').length) {
        $(document).on('click', '.btn-remove', function (e) {
            e.preventDefault();
            var cartItemKey = $(this).data('cart-item');

            $.ajax({
                url: wc_add_to_cart_params.ajax_url,
                type: 'POST',
                data: {
                    action: 'woocommerce_remove_cart_item',
                    cart_item_key: cartItemKey
                },
                success: function () {
                    $(document.body).trigger('removed_from_cart');
                }
            });
        });
    }

    if ($('.sidebar-cart-wrap .btn-number').length) {
        $('.sidebar-cart-wrap').on('click', '.btn-number', function () {
            var cartItemKey = $(this).data('cart-item');
            var actionType = $(this).data('type');
            var inputField = $('.input-number[data-cart-item="' + cartItemKey + '"]');
            var newQuantity = parseInt(inputField.val());

            if (actionType === 'plus') {
                newQuantity++;
            } else if (actionType === 'minus' && newQuantity > 1) {
                newQuantity--;
            }

            $.ajax({
                url: wc_add_to_cart_params.ajax_url,
                type: 'POST',
                data: {
                    action: 'woocommerce_update_cart_item',
                    cart_item_key: cartItemKey,
                    quantity: newQuantity,
                    nonce: wc_add_to_cart_params.wc_ajax_nonce
                },
                success: function (response) {
                    if (response.fragments) {
                        $.each(response.fragments, function (key, value) {
                            $(key).html(value);
                        });
                    }
                },
                error: function (xhr) {
                    console.log("AJAX Error:", xhr.responseText);
                }
            });
        });
    }
});
